import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ApiCalls } from '../../api/api';
import { ReportPeriodDto, TimeRegistrationForDate, TimesheetData } from '../../api/generated/data-contracts';
import { CURRENT_PERIOD } from '../../constants/queryKeys';

export interface IUpdateProps {
    date: string;
    timeRegistrations: TimeRegistrationForDate[];
    setDataSaved: React.Dispatch<React.SetStateAction<boolean>>;
    onSuccess?: () => void;
}

export const useUpdateFromTotalCell = () => {
    const queryClient = useQueryClient();

    const { mutate: mutateTotalCell } = useMutation(
        (updateProps: IUpdateProps) => ApiCalls.registerTimeEntries({ timeRegistrations: updateProps.timeRegistrations }).then(res => res.data),
        {
            onSuccess: (data, props) => {
                if (data === null) {
                    return;
                }

                const assignmentId = data.length ? data[0].assignment?.id : undefined;

                if (assignmentId) {
                    queryClient.setQueryData<ReportPeriodDto>([CURRENT_PERIOD, props.date], (prevState: ReportPeriodDto) => {
                        const newEntries = prevState.timesheetData.rows.map(m => {
                            if (m.assignmentId !== assignmentId) {
                                return m;
                            }

                            return {
                                ...m,
                                timeEntries: data,
                            };
                        });

                        const newTimesheetData: TimesheetData = {
                            ...prevState.timesheetData,
                            rows: newEntries,
                        };

                        return {
                            ...prevState,
                            timesheetData: newTimesheetData,
                        };
                    });
                }

                props.setDataSaved(false);

                // Call the provided onSuccess callback if it exists
                if (props.onSuccess) {
                    props.onSuccess();
                }
            },
        },
    );

    return { mutateTotalCell };
};
